export class LookupNode {
  children: LookupNode[];
  name: string;
  value: any;
  id: number = null;
  updated = false;
  isCategory?: boolean;
}
